<ul class="secuence">
    <!-- Preparation -->
    <li>
        <div class="secuence-header">
            <div class="secuence-ball" [class.active]="orderCurrentStatus.preparation || orderCurrentStatus.confirmed || orderCurrentStatus.canceled">
                <svg-icon
                    *ngIf="orderCurrentStatus.preparation || orderCurrentStatus.confirmed || orderCurrentStatus.canceled"
                    src="check-white"
                ></svg-icon>
            </div>
            <div class="secuence-title text-l">{{ 'dev.orderStatus.F' | translate }}</div>
        </div>
        <ng-container *ngIf="(hideDeliveryDates$ | async) === false">
            <div class="secuence-description text-m c-gray">
                <span *ngIf="orderStatusUpdated.confirmed && !orderStatusUpdated.preparation">
                    {{ (orderStatusUpdated.confirmed | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
                </span>

                <span *ngIf="orderStatusUpdated.preparation">
                    {{ (orderStatusUpdated.preparation | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
                </span>
            </div>
        </ng-container>
    </li>

    <!-- Cancelled -->
    <li *ngIf="orderCurrentStatus.canceled">
        <div class="secuence-header">
            <div class="secuence-ball canceled has-light">
                <svg-icon src="close"></svg-icon>
            </div>
            <div class="secuence-title text-l">{{ 'dev.orderStatus.X' | translate }}</div>
        </div>
        <div class="secuence-description text-m c-gray">
            <span *ngIf="orderStatusUpdated.canceled">
                {{ (orderStatusUpdated.canceled | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
            </span>
        </div>
    </li>

    <!-- Courier -->
    <li *ngIf="!orderCurrentStatus.canceled">
        <div class="secuence-header">
            <div class="secuence-ball" [class.active]="orderCurrentStatus.courier">
                <svg-icon *ngIf="orderCurrentStatus.courier" src="check-white"></svg-icon>
            </div>
            <div class="secuence-title text-l">{{ 'dev.orderStatus.courier' | translate }}</div>
        </div>
        <div class="secuence-description text-m c-gray">
            <ng-container *ngIf="(hideDeliveryDates$ | async) === false">
                <span *ngIf="orderCurrentStatus.courier && orderStatusUpdated.courier">
                    {{ (orderStatusUpdated.courier | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
                </span>
            </ng-container>

            <div *ngIf="orderCurrentStatus.courier && !orderCurrentStatus.dispatch && (courier || trackingNumber)">
                <div *ngIf="courier">
                    <strong>{{ 'legacy.order_tracking.courier' | translate }}:</strong>
                    <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                        <span>{{ courier }}</span>
                    </a>

                    <span *ngIf="!urlTracking" class="info-tracking">{{ courier }}</span>
                </div>

                <div *ngIf="trackingNumber">
                    <strong>{{ 'legacy.order_tracking.trackingNumber' | translate }}:</strong>
                    <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                        <span>{{ trackingNumber }}</span>
                    </a>
                    <span class="info-tracking" *ngIf="!urlTracking">{{ trackingNumber }}</span>
                </div>
            </div>
        </div>
    </li>

    <li *ngIf="!orderCurrentStatus.canceled">
        <div class="secuence-header">
            <div class="secuence-ball" [class.active]="orderCurrentStatus.dispatch">
                <svg-icon *ngIf="orderCurrentStatus.dispatch" src="check-white"></svg-icon>
            </div>
            <div *ngIf="shippingKind === 'delivery'" class="secuence-title text-l">{{ 'dev.orderStatus.dispatch' | translate }}</div>
            <div *ngIf="shippingKind === 'pickup'" class="secuence-title text-l">{{ 'legacy.Messages_enTienda' | translate }}</div>
            <div *ngIf="shippingKind === 'droppoint'" class="secuence-title text-l">{{ 'legacy.droppoint' | translate }}</div>
        </div>
        <div class="secuence-description text-m c-gray">
            <div *ngIf="shippingKind === 'pickup' || shippingKind === 'droppoint'">
                <span>{{ orderAddress?.addressLines }}</span> <br />
                <span>{{ orderAddress?.physicalStore?.zipCode }} </span>
                <span>{{ orderAddress?.physicalStore?.state }} </span>
                <span>{{ orderAddress?.district }}</span>
            </div>

            <ng-container *ngIf="(hideDeliveryDates$ | async) === false">
                <span *ngIf="orderCurrentStatus.dispatch && orderStatusUpdated.dispatch">
                    {{ (orderStatusUpdated.dispatch | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
                </span>

                <span *ngIf="(shippingKind === 'pickup' || shippingKind === 'droppoint') && !orderCurrentStatus.dispatch">
                    {{ 'dev.myAccount.orders.detail.estimatedShipment' | translate }}:
                    <span>{{ deliveryDate$ | async }}</span>
                </span>
            </ng-container>

            <div
                *ngIf="orderCurrentStatus.dispatch && !orderCurrentStatus.delivered && shippingKind === 'delivery' && (courier || trackingNumber)"
                class="info-tooltip hidden-xs hidden-sm"
            >
                <div *ngIf="courier">
                    <strong>{{ 'legacy.order_tracking.courier' | translate }}:</strong>
                    <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                        <span>{{ courier }}</span>
                    </a>
                    <span *ngIf="!urlTracking" class="info-tracking">{{ courier }}</span>
                </div>
                <div *ngIf="trackingNumber">
                    <strong>{{ 'legacy.order_tracking.trackingNumber' | translate }}:</strong>
                    <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                        <span>{{ trackingNumber }}</span>
                    </a>
                    <span *ngIf="!urlTracking" class="info-tracking">{{ trackingNumber }}</span>
                </div>
            </div>
        </div>
    </li>

    <!-- Delivered -->
    <li *ngIf="!orderCurrentStatus.canceled">
        <div class="secuence-header">
            <div class="secuence-ball" [class.active]="orderCurrentStatus.delivered">
                <svg-icon *ngIf="orderCurrentStatus.delivered" src="check-white"></svg-icon>
            </div>
            <div class="secuence-title text-l">{{ 'dev.orderStatus.K' | translate }}</div>
        </div>
        <div class="secuence-description text-m c-gray">
            <div *ngIf="shippingKind === 'delivery'">
                <span>{{ orderAddress?.addressLines }}</span> <br />
                <span>{{ orderAddress?.address.zipCode }} </span>
                <span>{{ orderAddress?.address.stateName }} </span>
                <span>{{ orderAddress?.district }}</span>
            </div>

            <ng-container *ngIf="(hideDeliveryDates$ | async) === false">
                <span *ngIf="orderCurrentStatus.delivered && orderStatusUpdated.delivered">
                    {{ (orderStatusUpdated.delivered | date: 'dd/MM/yyyy - HH:mm') + 'h' }}
                </span>

                <span *ngIf="shippingKind === 'delivery' && !orderCurrentStatus.delivered">
                    {{ 'dev.myAccount.orders.detail.estimatedShipment' | translate }}:
                    <span>{{ deliveryDate$ | async }}</span>
                </span>
            </ng-container>
        </div>
    </li>

    <li *ngIf="showTracking">
        <div class="secuence-header">
            <div class="secuence-ball" [class.active]="orderCurrentStatus.delivered">
                <svg-icon *ngIf="orderCurrentStatus.delivered" src="check-white"></svg-icon>
            </div>
            <div class="secuence-title text-l">{{ 'legacy.order_tracking.courier_intro' | translate }}</div>
        </div>
        <div class="secuence-description text-m c-gray">
            <div *ngIf="courier">
                <strong>{{ 'legacy.order_tracking.courier' | translate }}:</strong>
                <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                    <span>{{ courier }}</span>
                </a>
                <span class="info-tracking" *ngIf="!urlTracking">{{ courier }}</span>
            </div>

            <div *ngIf="trackingNumber">
                <strong>{{ 'legacy.order_tracking.trackingNumber' | translate }}:</strong>
                <a *ngIf="urlTracking" [href]="urlTracking" target="_blank">
                    <span>{{ trackingNumber }}</span>
                </a>
                <span *ngIf="!urlTracking" class="info-tracking">{{ trackingNumber }}</span>
            </div>
        </div>
    </li>
</ul>
